import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32fc750c")

_pushScopeId("data-v-32fc750c")
const _hoisted_1 = { class: "px-30" }
const _hoisted_2 = { class: "t-center d-title f-bold f-lg df-middle df-between" }
const _hoisted_3 = { class: "d-left df-middle" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Dialog Title")
const _hoisted_5 = { class: "close-wrap" }
const _hoisted_6 = { class: "dialog__body df-middle" }
const _hoisted_7 = { class: "dialog__controls f-medium py-20 t-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Line = _resolveComponent("Line")
  const _component_t = _resolveComponent("t")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.noTitle)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "left", {}, undefined, true),
              _renderSlot(_ctx.$slots, "title", {}, () => [
                _hoisted_4
              ], {}, true)
            ]),
            _createVNode("span", _hoisted_5, [
              _renderSlot(_ctx.$slots, "right", {}, undefined, true)
            ])
          ]),
          _createVNode(_component_Line)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "controls", {}, () => [
        _renderSlot(_ctx.$slots, "cancel", {}, () => [
          _createVNode("button", {
            class: "btn line",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, [
            _renderSlot(_ctx.$slots, "cancelText", {}, () => [
              _createVNode(_component_t, {
                path: "withdrawal_30",
                custom: ""
              }, {
                default: _withId(({td}) => [
                  _createTextVNode(_toDisplayString(td || 'Cancel'), 1)
                ]),
                _: 1
              })
            ], {}, true)
          ])
        ], {}, true),
        _renderSlot(_ctx.$slots, "confirm", {}, () => [
          _createVNode("button", {
            class: "btn primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, [
            _renderSlot(_ctx.$slots, "confirmText", {}, () => [
              _createVNode(_component_t, {
                path: "withdrawal_31",
                custom: ""
              }, {
                default: _withId(({td}) => [
                  _createTextVNode(_toDisplayString(td || 'Confirm'), 1)
                ]),
                _: 1
              })
            ], {}, true)
          ])
        ], {}, true)
      ], {}, true)
    ])
  ]))
})